/**
 * Règle de choix du fond du bandeau d'Aerith, sans rien d'autre : seulement du calcul, pour pouvoir la tester seule.
 *
 * - choix manuel (depuis le tableau de bord) : il l'emporte jusqu'à son expiration (30 minutes, comptées par le serveur) ;
 * - sinon, rotation automatique : un fond après l'autre, chacun pendant `rotationMinutes` minutes.
 *   La rotation se déduit de l'heure (et non d'un minuteur) : tous les écrans, et tous les rechargements de page,
 *   affichent le même fond au même moment, sans rien se dire.
 */

/**
 * @param ids              identifiants des fonds disponibles, dans l'ordre du registre
 * @param rotationMinutes  durée d'affichage de chaque fond en rotation automatique
 * @param choisi           identifiant choisi à la main, ou null
 * @param expireA          instant (ms) où le choix manuel expire
 * @param rotationActive  faux : pas de rotation, le fond choisi à la main reste sans limite de durée (sinon, le premier fond de la rotation)
 * @param exclus           identifiants retirés de la rotation automatique (ils restent choisissables à la main) ; ceux qui
 *                         n'existent plus sont ignorés, et si tous sont retirés la rotation reprend avec tous les fonds
 * @param maintenant       instant courant (ms)
 * @returns l'identifiant du fond à afficher, ou null s'il n'y a aucun fond
 */
export function fondActuel({ids, rotationMinutes, choisi, expireA, maintenant, exclus = [], rotationActive = true}) {
    if (!ids.length) return null;
    if (choisi && ids.includes(choisi) && (!rotationActive || maintenant < expireA)) return choisi;

    const rotation = fondsEnRotation(ids, exclus);
    if (!rotationActive) return rotation[0];
    const duree = Math.max(1, Number(rotationMinutes) || 1) * 60000;
    return rotation[Math.floor(maintenant / duree) % rotation.length];
}

/** Fonds de la rotation automatique : tous sauf les exclus ; si tous sont exclus, tous (l'écran ne reste jamais sans fond). */
export function fondsEnRotation(ids, exclus = []) {
    const gardes = ids.filter(id => !exclus.includes(id));
    return gardes.length ? gardes : ids;
}

/** Secondes avant le retour à la rotation automatique ; 0 s'il n'y a pas de choix manuel en cours. */
export function secondesAvantRetour({choisi, expireA, maintenant}) {
    return choisi && maintenant < expireA ? Math.ceil((expireA - maintenant) / 1000) : 0;
}

/** Secondes avant le prochain changement de fond en rotation automatique. */
export function secondesAvantChangement({rotationMinutes, maintenant}) {
    const duree = Math.max(1, Number(rotationMinutes) || 1) * 60000;
    return Math.ceil((duree - (maintenant % duree)) / 1000);
}
